(function () {
  var overlay = document.getElementById('tutorial-video-overlay');
  if (!overlay) return;
  var closeBtn = document.getElementById('tutorial-video-close');
  var frame = document.getElementById('tutorial-video-frame');
  var videoId = window.moonTutorialVideoId;
  if (!closeBtn || !frame || !videoId) return;

  function openModal() {
    frame.innerHTML =
      '<iframe src="https://www.youtube-nocookie.com/embed/' +
      videoId +
      '?autoplay=1&rel=0" title="Tutorial MoonCase — cum se aplică un skin" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    overlay.hidden = false;
    document.body.classList.add('tutorial-video-lock-scroll');
  }

  function closeModal() {
    overlay.hidden = true;
    frame.innerHTML = '';
    document.body.classList.remove('tutorial-video-lock-scroll');
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeModal();
  });
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-tutorial-video-trigger]');
    if (!trigger) return;
    e.preventDefault();
    openModal();
  });
})();
